module.exports = __webpack_public_path__ + "static/media/cc-by-nc-nd.a4212c1a.png";